import DealerSearchAppData from '@/models/dealer-search-app-data.model';

export default window.dealerSearchAppData as DealerSearchAppData;